<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee">
            <div class="text-center">
                <img
                    class="wrapper_title_logo margin-logo"
                    src="@/assets/home/logo-new-theme.png"
                />
            </div>
            <div class="wrapper__profile">
                <NewProfile />
            </div>
            <div class="dashboard-container">
                <DashboardPrivilege />
            </div>
            <!-- close by blob config -->
            <div class="mission-container">
                <div class="title-header">ภารกิจพิเศษ</div>
                <div
                    v-if="
                        missionMenu && missionMenu.length !== 0 && checkConfig
                    "
                >
                    <div
                        id="privilege-mission-btn"
                        v-for="(item, index) in missionMenu"
                        :key="index"
                        class="mission-main"
                    >
                        <div @click="goto(item.path)" class="mission-item">
                            <div class="left-content">
                                <img :src="item.imageUrl" />
                                <div class="mission-text">
                                    <div class="mission-title">
                                        {{ item.title }}
                                    </div>
                                    <div class="mission-desc">
                                        {{ item.desc }}
                                    </div>
                                </div>
                            </div>
                            <img
                                class="mission-arrow"
                                src="@/assets/icon/ic_circle_arrow.svg"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
                <div v-else class="text-center mt-5 not-campaign">
                    พบกันเร็วๆนี้
                </div>
            </div>
            <div class="news-container">
                <div class="wrapper__dashboard">
                    <div class="dashboard__left">News</div>
                </div>
                <div class="news-wrapper">
                    <campaign-list
                        ref="campaignlist"
                        :lbl="lbl"
                        :isLoading="isLoading"
                        :initListConfig="campaignListConfig"
                        :initFilterConfig="campaginListFilterConfig"
                        :busEvent="busCategory"
                        :isslide="true"
                        :showPoint="false"
                        :isClickCampaign="true"
                        :isNews="true"
                        @toggleLoading="toggleLoading($event)"
                    >
                    </campaign-list>
                </div>
            </div>
            <Footer :settabactive="'privilege'" />
        </div>
        <div>
            <b-modal
                id="modalTerm"
                modal-class="modal-list-address"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="modal-base">
                    <div class="modal-base-body pb-4">
                        <Terms />
                    </div>
                </div>
                <div class="modal-base-footer text-center">
                    <div>
                        <button
                            id="privilege-modalterm-close-btn"
                            class="btn btn-close-pdpa"
                            @click="$bvModal.hide('modalTerm')"
                        >
                            ปิด
                        </button>
                        <button
                            id="privilege-modalterm-update-btn"
                            class="btn btn-submit-pdpa-regis"
                            @click="updateVersionTermPdpa()"
                        >
                            ยอมรับ
                        </button>
                    </div>
                </div>
            </b-modal>
        </div>
        <div>
            <b-modal
                id="modalPDPA"
                modal-class="modal-list-address"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="modal-base">
                    <div class="modal-base-body pb-4">
                        <Pdpa />
                    </div>
                </div>
                <div class="modal-base-footer text-center">
                    <div>
                        <button
                            id="privilege-modalpdpa-close-btn"
                            class="btn btn-close-pdpa"
                            @click="$bvModal.hide('modalPDPA')"
                        >
                            ปิด
                        </button>
                        <button
                            id="privilege-modalpdpa-update-btn"
                            class="btn btn-submit-pdpa-regis"
                            @click="updateVersionTermPdpa()"
                        >
                            ยอมรับ
                        </button>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
// helper
import Locale from "@/helper/locale/locale.js";
import DashboardPrivilege from "@/components/Dashboard/DashboardPrivilege.vue";
// core
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder,
} from "@/core/Campaign/model/CampaignConfigModel.js";
// component
import NewProfile from "@/module/List/component/NewProfile.vue";
import CampaignList from "../component/CampaignList.vue";
import Footer from "@/components/Footer/Footer.vue";
import Terms from "@/module/Static/page/Terms.vue";
import Pdpa from "@/components/PDPA/Page/PDPA.vue";
//mixin
import CheckLogin from "@/mixin/CheckLogin.js";
import Mixin from "@/mixin/Mixin";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
import Account from "@/helper/AccountHelper.js";
//core
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
import MenuApi from "@/module/Menu/service/missionbadge.js";
//vuex
import { mapActions } from "vuex";

export default {
    name: "Category",
    components: {
        CampaignList,
        NewProfile,
        Footer,
        DashboardPrivilege,
        Terms,
        Pdpa,
    },
    mixins: [Mixin, CheckLogin],
    data: function () {
        return {
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),
            isLoading: false,
            //config
            categoryConfig: {},
            campaignListConfig: {},
            campaginListFilterConfig: {},
            //bus
            busCategory: new Vue(),
            tab: "rewards",
            pdpaTermVersion: {},
            cacheHelper: new CacheHelper(),
            consent: {},
            tokenbzbs: null,
            line_image: null,
            profile: {},

            missionMenu: [],
            checkConfig: true,
            tier: "",
            point: "",
        };
    },
    // watch: {
    //     missionMenu(newVal, oldVal) {
    //         this.missionMenu = newVal
    //         console.log(oldVal)
    //     },
    // },
    mounted() {
        var cacheHelper = new CacheHelper("cookie");
        this.tokenbzbs = cacheHelper.getCache("BzbsUser").token;
        // this.apiGetPdpaTermsVersion();
        // this.getConsent();
    },
    created: async function () {
        this.handleLoading(true);
        this.line_image = this.cacheHelper.getCache("BzbsUser").line.pictureUrl;
        // this.initialCategory();
        await this.initialCampaign();
        await this.getProfile();
        Promise.all([this.getMission(), this.updateUserlevel()]).then(() => {
            this.$refs.campaignlist.getList().then(() => {
                this.handleLoading(false);
            });
        });
    },
    methods: {
        ...mapActions(["setUserlevel"]),
        updateUserlevel() {
            let userToken = this.cacheHelper.getCache("BzbsUser").token;

            let userData = Account.getCacheUser().userId;

            //set new user level
            BzbsAuth.apiReLoginDevice(userToken, userData).subscribe(
                (data) => {
                    // console.log(data);
                    // console.log(this.cacheHelper.getCache("BzbsUser"))
                    let newData = { ...this.cacheHelper.getCache("BzbsUser") };
                    newData.token = data.token;
                    newData.jwt = data.jwt;
                    newData.userLevel = data.userLevel;
                    newData.userLevelDetail = data.userLevelDetail;
                    this.cacheHelper.setCache("BzbsUser", newData);
                },
                (err) => {
                    console.log(err);
                }
            );
            this.getGlassPoint();
        },
        getMission() {
            return new Promise((resolve) => {
                MenuApi.GetTabBlob()
                    .then((response) => {
                        this.missionMenu = response.data.list;
                        this.checkConfig = response.data.config;
                        resolve(this.missionMenu);
                        // console.log(this.missionMenu)
                    })
                    .catch((err) => {
                        console.log("error ::::    ", err);
                    });
            });
        },
        numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (x == 0) {
                return 0;
            } else {
                return "-";
            }
        },
        apiGetPdpaTermsVersion: function () {
            BzbsPDPA.apiGetPDPAVersion().subscribe(
                (data) => {
                    this.pdpaTermVersion = data;
                },
                (err) => {
                    this.errorResponse(err);
                }
            );
        },
        updateVersionTermPdpa() {
            BzbsPDPA.apiPostConsent(
                this.tokenbzbs,
                this.pdpaTermVersion.terms.current_version,
                this.pdpaTermVersion.privacy.current_version
            ).subscribe(
                () => {
                    this.$bvModal.hide("modalPDPA");
                    this.$bvModal.hide("modalTerm");
                },
                (err) => {
                    console.log("apiPostTermPDPAVersion error", err);
                }
            );
        },
        getConsent: function () {
            BzbsPDPA.apiGetConsent(this.tokenbzbs).subscribe(
                (data) => {
                    this.consent = data;
                    if (
                        this.pdpaTermVersion.terms.current_version !=
                        data.TermAndCondition
                    ) {
                        setTimeout(() => {
                            this.$bvModal.show("modalTerm");
                            console.log(
                                this.pdpaTermVersion.terms.current_version,
                                this.consent.TermAndCondition,
                                "term"
                            );
                        }, 1000);
                    }
                    if (
                        this.pdpaTermVersion.privacy.current_version !=
                        data.DataPrivacy
                    ) {
                        setTimeout(() => {
                            this.$bvModal.show("modalPDPA");
                            console.log(
                                this.pdpaTermVersion.privacy.current_version,
                                this.consent.DataPrivacy,
                                "pdpa"
                            );
                        }, 1000);
                    }
                },
                (err) => {
                    this.errorResponse(err);
                }
            );
        },
        initialCampaign() {
            return new Promise((resolve) => {
                this.campaignListConfig = {};
                this.campaginListFilterConfig = {};

                var listConfig = new CampaignListConfigBuilder()
                    .setConfigList("campaign_nescafestreetcafe_news")
                    .setTop(25);

                this.campaignListConfig = listConfig.create();

                var filterConfig = new CampaignListFilterConfigBuilder();
                this.campaginListFilterConfig = filterConfig.create();
                resolve(this.campaginListFilterConfig);
            });
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
        clickTab: function (tab) {
            this.tab = tab;
            this.$emit("clickTab", this.tab);
        },
        goto(page) {
            this.$router.push("/" + page);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/_mixin.scss";
.margin-logo {
    margin-bottom: 10px;
}
.dashboard-container {
    margin-top: 20px;
}
.main-layout {
    padding-bottom: 70px;
}
.mission-container {
    padding: 0px 21px 15px;
    .not-campaign {
        font-size: 22px;
        color: white;
    }
    .title-header {
        color: $color-light-grey-900;
        font-family: "PromptSemiBold";
        font-size: 16px;
        margin-bottom: 15px;
    }
    .mission-main {
        margin-bottom: 15px;
        .mission-item {
            padding: 15px;
            background-color: $color-light-grey-500;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 1px $color-light-grey-600 solid;
            border-radius: 15px;

            .left-content {
                display: flex;
                img {
                    height: 60px;
                }
                .mission-text {
                    margin-left: 15px;
                    .mission-title {
                        font-family: "PromptSemiBold";
                        font-size: 16px;
                        color: $color-brown-900;
                        padding: 5px 0;
                    }
                    .mission-desc {
                        padding-right: 15px;
                        font-family: "PromptRegular";
                        font-size: 14px;
                        color: $color-brown-800;
                    }
                }
            }

            .mission-arrow {
                height: 24px;
                margin-right: -27px;
            }
        }
    }
}
.wrapper__profile {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    height: 20px;
    width: auto;
    min-height: 100px;
    background: #fff;
    border-radius: 15px;
    margin: 40px 20px 20px;
    .status {
        width: auto;
        height: 16px;
        margin-top: 15px;
    }
    .wrapper__point {
        background-color: white;
        color: #a7907b;
        .icon {
            width: 18px;
            margin-left: 8px;
        }
        text-align: center;
        border-radius: 15px;
        font-size: 18px;
        font-weight: bold;
    }
    .wrapper__unit {
        background-color: white;
        color: #a7907b;
        .icon {
            width: 18px;
            margin-left: 8px;
        }
        text-align: center;
        border-radius: 15px;
        font-size: 18px;
        font-weight: bold;
    }
}
.profile__image {
    width: 60px;
    height: 60px;
    border-radius: 45px;
    position: absolute;
    z-index: 1;
    top: 15px;
    left: 30px;
    border: solid 1px #fff;
}
.banner {
    width: 100%;
}
.wrapper__dashboard {
    width: 100%;
    padding: 0px 15px 0px 15px;
    .dashboard__left {
        text-align: left;
        font-size: 16px;
        color: $color-brown-900;
        font-family: "PromptSemiBold";
    }
}

.wrapper-bg {
    padding: 0;
    overflow: hidden;
}
</style>
